import { useCallback } from 'react'
import { useServiceProxy } from 'hooks/kong'
import { IncomingDynamoEvents } from 'types/api'
import { config } from '../../config'
import { isEmpty } from 'lodash-es'
import { TransformedTicket } from 'types/ticket'

export const useGetDuplicateLDREvent = () => {
  const serviceProxy = useCallback(useServiceProxy(), [])

  return async function (claim: any, currentTicket: TransformedTicket) {
    const vin = claim.vehicle.vin
    const ticketNumber = currentTicket?.ticketNumber

    const { data } = await serviceProxy<IncomingDynamoEvents>(
      'get',
      `/serviceproxy/events-table/items?rentalContext=${config.rentalAgreementUrn}${ticketNumber}`,
    )

    const duplicate = data?.Items?.find((item) => item?.eventType === 'ldr' && item?.attributes?.claim?.vehicle?.vin === vin)

    if (duplicate && !isEmpty(duplicate)) return duplicate
    else return {}
  }
}
